<template>
    <div
        :class="[
            'web-community-discussion-list-root',
            {
                isPC: isPC,
                white: theme === THEME.WHITE,
                black: theme === THEME.BLACK,
                'hide-discussion': !showDiscussion,
                ja: contentLang === LANG.LANG_JA
            }
        ]"
    >
        <!-- isPreRender 处理预渲染下的兼容，防止空注释节点 -->
        <div v-if="isPreRender" key="hideContent"></div>
        <div v-else-if="showData" key="showContent" class="data-container">
            <a v-if="showDiscussion" href="javascript:;" class="discussion-container" @click="onClickDiscussion()">
                <div class="title bold">{{ discussionTitle }}</div>
                <div v-if="showBrowseCount && discussionBrowseCount" class="browse-count">{{discussionBrowseCount}}</div>
            </a>
            <div class="discussion-content-list">
                <a
                    v-for="item in discussionFeedList"
                    :key="item.id"
                    href="javascript:;"
                    class="list-item"
                    @click="onClickDiscussionFeed(item)"
                >
                    <div class="user">
                        <div class="avatar" :style="`backgroundImage: url(${item.avator})`"></div>
                        <div class="name-publish-time">
                            <div class="name bold">{{ item.nick }}</div>
                            <div class="publish-time">{{ formatTime(item.time) }}</div>
                        </div>
                    </div>
                    <div class="content-title bold">{{ item.title }}</div>
                    <div class="content-stock-info" v-if="item.stockInfos && item.stockInfos.length">
                        <a
                            href="javascript:;"
                            v-for="stockInfo in item.stockInfos"
                            :key="stockInfo.stockId"
                            @click="onClickStockInfo($event, stockInfo)"
                            >${{ stockInfo.stockSymbol }}$&nbsp;</a
                        >
                    </div>
                    <div
                        class="content-description"
                        :class="[
                            {
                                'has-stock-info': item.stockInfos && item.stockInfos.length
                            }
                        ]"
                        v-html="formatText(item.texts)"
                    ></div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

// 这个方法不会区分是富途牛牛App还是美分moomoo APP,富途牛牛和mooomoo都会判断为true

const { plugins: { weblib } } = require('@futuweb/fego-render');
const {isMobileNN } = weblib['@futuweb/tool-browser'];
import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';
import { getEntity } from '../utils';
import CONSTANTS from '../constants';
const {
    common: {
        request: { bindCommonApi },
        behavior: { runBehaviour }
    }
} = FEGORender;
const commonApiRequest = bindCommonApi('web-community-discussion-list');

const langMap = {
    0: 'zh-cn',
    1: 'zh-hk',
    2: 'en-us',
    5: 'ja'
};

const toolDateFormatter = new ToolDateFormatter({
    entity: getEntity()
});

export default {
    name: 'web-community-discussion-list',
    props: {
        discussionId: {
            type: Number,
            default: 0
        },
        theme: {
            type: String,
            default: CONSTANTS.THEME.WHITE
        },
        showDiscussion: {
            type: Boolean,
            default: true
        },
        showBrowseCount: {
            type: Boolean,
            default: true
        },
        contentLang: {
            type: Number
        },
        contentNum: {
            type: Number,
            default: 3
        },
        orderType: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            THEME: CONSTANTS.THEME,
            LANG: CONSTANTS.LANG,
            discussionInfo: null,
            discussionFeedList: null,
            isPC: FEGORender.store.route.now.pageType === 10,
            isPreRender: FEGORender.common.env.isPreRender,
            isMoo: location.host.indexOf('moomoo.com') > -1
        };
    },
    computed: {
        showData() {
            return this.discussionInfo && this.discussionFeedList && this.discussionFeedList.length;
        },
        discussionTitle() {
            if (this.discussionInfo && this.discussionInfo.discussionTitle) {
                return this.discussionInfo.discussionTitle[CONSTANTS.LANG_NUM_STRING_MAP[this.contentLang]];
            }
            return '';
        },
        discussionBrowseCount() {
            if (this.discussionInfo && this.discussionInfo.browseCount) {
                return this.formatBrowseCountStr(this.discussionInfo.browseCount);
            }
            return '';
        }
    },
    async mounted() {
        await this.getData();
    },
    methods: {
        async getData() {
            await this.getDiscussionInfo();
            // 请求到话题信息后，再请求话题下的 feed 列表
            if (this.discussionInfo) {
                await this.getDiscussionFeedList();
            }
        },
        async getDiscussionInfo() {
            if (+this.discussionId !== 0) {
                const res = await commonApiRequest.get(
                    'getDiscussionInfo',
                    {
                        lang: this.contentLang,
                        discussionId: this.discussionId
                    },
                    {
                        group: null
                    }
                );
                this.discussionInfo = res;
            }
        },
        // 通过话题id获取其关联的 feed 列表
        async getDiscussionFeedList() {
            if (+this.discussionId !== 0) {
                const resArr = await commonApiRequest.get(
                    'getDiscussionFeedList',
                    {
                        lang: this.contentLang,
                        size: this.contentNum,
                        discussionId: this.discussionId,
                        orderType: this.orderType
                    },
                    {
                        group: null
                    }
                );
                this.discussionFeedList = resArr;
            }
        },
        formatTime(timestamp) {
            return toolDateFormatter.dateFormatByTemplate({
                dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
                timestamps: timestamp * 1e3,
                lang: this.contentLang
            });
        },
        // 纯文本内容
        formatText(texts) {
            let showText = '';
            if (texts) {
                texts.forEach((text) => {
                    if (+text.type === CONSTANTS.FEED_TYPE.TEXT) {
                        showText = showText + `<span>${text.text || ''}</span>`;
                    } else if (+text.type === CONSTANTS.FEED_TYPE.TEXT_LINK) {
                        showText = showText + `<span class="link">${(text.textLink && text.textLink.text) || ''}</span>`;
                    } else if (+text.type === CONSTANTS.FEED_TYPE.STOCK && text.stockSymbol) {
                        showText = showText + `<span class="stock">$${(text.stockSymbol)}$</span>`;
                    }
                });
                showText = showText.trim();
            }
            return showText;
        },
        // 话题的跳转链接
        onClickDiscussion() {
            const lang = langMap[this.contentLang];

            if (isMobileNN()) {
                // 站内
                const link = this.isMoo
                    ? `ftnn://nncircle/discussion/${this.discussionId}`
                    : `ftmm://nncircle/discussion/${this.discussionId}`;

                return runBehaviour(this, {
                    type: 'jump',
                    value: link
                });
            } else {
                // 站外
                let link = this.isMoo
                    ? `https://www.moomoo.com/community/discussion/${this.discussionId}?lang=${lang}`
                    : `https://q.futunn.com/community/discussion/${this.discussionId}?lang=${lang}`;

                // 互联网业务侧日本站点是单独
                if (lang === 'ja' && this.isMoo) {
                    link = `https://www.moomoo.com/ja/community/discussion/${this.discussionId}?lang=${lang}`;
                }

                return runBehaviour(this, {
                    type: 'link',
                    value: link,
                    withQuery: true
                });
            }
        },
        // 话题下feed的跳转链接
        onClickDiscussionFeed(feed) {
            const lang = langMap[this.contentLang];

            if (isMobileNN()) {
                // 站内
                const link = this.isMoo ? `ftmm://nncircle/feed/${feed.id}` : `ftnn://nncircle/feed/${feed.id}`;

                return runBehaviour(this, {
                    type: 'jump',
                    value: link
                });
            } else {
                // 站外
                let link = this.isMoo
                    ? `https://www.moomoo.com/community/feed/${feed.id}?lang=${lang}`
                    : `https://q.futunn.com/community/feed/${feed.id}?lang=${lang}`;

                // 互联网业务侧日本站点是单独
                if (lang === 'ja' && this.isMoo) {
                    link = `https://www.moomoo.com/ja/community/feed/${feed.id}?lang=${lang}`;
                }

                return runBehaviour(this, {
                    type: 'link',
                    value: link,
                    withQuery: true
                });
            }
        },
        // 股票链接点击跳转
        onClickStockInfo($event, stockInfo) {
            $event.stopPropagation();
            const lang = langMap[this.contentLang];

            if (isMobileNN()) {
                // 站内
                const link = this.isMoo
                    ? `ftmm://quote/stockDetail/${stockInfo.stockId}/1/1`
                    : `ftnn://quote/stockDetail/${stockInfo.stockId}/1/1`;

                return runBehaviour(this, {
                    type: 'jump',
                    value: link
                });
            } else {
                // 站外
                const stockSymbol = stockInfo.stockSymbol.replace(/\./g, '-');
                let link = this.isMoo
                    ? `https://www.moomoo.com/stock/${stockSymbol}?lang=${lang}`
                    : `https://www.futunn.com/stock/${stockSymbol}?lang=${lang}`;

                // 互联网业务侧日本站点是单独
                if (lang === 'ja' && this.isMoo) {
                    link = `https://www.moomoo.com/ja/stock/${stockSymbol}?lang=${lang}`;
                }

                return runBehaviour(this, {
                    type: 'link',
                    value: link,
                    withQuery: true
                });
            }
        },
        // 话题信息浏览量处理
        formatBrowseCountStr(browseCount) {
            const lang = langMap[this.contentLang];
            const unitStrMap = {
                'zh-cn': '万',
                'zh-hk': '萬'
            };
            const browseStrMap = {
                'zh-cn': '浏览',
                'zh-hk': '瀏覽',
                'en-us': 'Views',
                'ja': '閲覧'
            };
            const browseStr = browseStrMap[lang];
            let result = browseCount;

            if (browseCount > 10000) {
                if (['zh-cn', 'zh-hk'].includes(lang)) {
                    const num = Math.floor(browseCount / 10000);
                    const decimal = Math.floor((browseCount % 10000) / 1000);
                    if (decimal === 0) {
                        result = `${num}${unitStrMap[lang]}`;
                    } else {
                        result = `${num}.${decimal}${unitStrMap[lang]}`;
                    }
                } else if (['en-us', 'ja'].includes(lang)) {
                    const num = Math.floor(browseCount / 1000);
                    const decimal = Math.floor((browseCount % 1000) / 100);
                    if (decimal === 0) {
                        result = `${num}K`;
                    } else {
                        result = `${num}.${decimal}K`;
                    }
                }
            }

            if (['zh-cn', 'zh-hk'].includes(lang)) {
                result = `${browseStr} ${result}`;
            } else if (['en-us', 'ja'].includes(lang)) {
                result = `${result} ${browseStr}`;
            }

            return result;
        }
    }
};
</script>

<style lang="less" scoped>
.web-community-discussion-list-root {
    height: auto !important;
    // 对照社区侧，指定 fego 支持的字体和一部分系统字体
    font-family: brRegular, 'FZLanTingHei-R-GBK', 'BR Hendrix', 'PingFang SC', 'PingFang HK', -apple-system,
        'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'ヒラギノ角ゴ Pro W3',
        'Hiragino Kaku Gothic Pro', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic';
    .bold {
        font-family: brSemiBold, 'FZLanTingHeiS-DB1-GBK';
    }
    &.ja {
        font-family: brRegular, 'SourceHanSansJP-Regular', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', Meiryo,
            'ＭＳ Ｐゴシック', 'MS PGothic', 'BR Hendrix', 'PingFang SC', 'PingFang HK', -apple-system,
            'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        .bold {
            font-family: brSemiBold, 'SourceHanSansJP-Bold';
        }
    }

    background-color: #ffffff;
    .data-container {
        padding: 0rem 0.4rem;
    }

    // 默认样式
    .discussion-container {
        padding: 0.4rem 0.3rem;
        background-color: #f4f7ff;
        display: block;
        border-radius: 0.1rem;
        .title {
            font-size: 0.36rem;
            color: #121212;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .browse-count {
            margin-top: 0.24rem;
            font-size: 0.2rem;
            color: #7a7a7a;
        }
    }
    .discussion-content-list {
        .list-item {
            padding: 0.5rem 0;
            position: relative;
            display: block;
            .user {
                display: flex;
                align-items: center;
                margin-bottom: 0.32rem;
                .avatar {
                    flex-shrink: 0;
                    width: 0.72rem;
                    height: 0.72rem;
                    border-radius: 0.36rem;
                    margin-right: 0.2rem;
                    background-size: cover;
                }
                .name-publish-time {
                    min-width: 0;
                    .name {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 0.28rem;
                        color: #262626;
                        margin-bottom: 0.06rem;
                    }
                    .publish-time {
                        font-size: 0.24rem;
                        color: #7a7a7a;
                    }
                }
            }
            .content-title {
                font-size: 0.36rem;
                color: #262626;
                margin-bottom: 0.14rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                word-break: break-word;
            }
            .content-stock-info {
                font-size: 0.26rem;
                color: rgba(14, 85, 201, 0.8);
                word-break: break-word;
                margin-bottom: 0.14rem;
                a {
                    color: rgba(14, 85, 201, 0.8);
                }
            }
            .content-description {
                font-size: 0.3rem;
                color: #262626;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                word-break: break-word;
                // 有股票信息的情况下，少一行
                &.has-stock-info {
                    -webkit-line-clamp: 4;
                }
                /deep/ .link {
                    color: #0e55c9cc;
                }

                /deep/ .stock {
                    color: #0e55c9cc;
                }
            }
            &::after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 1px;
                background-color: #e5e5e5;
            }
            &:first-child {
                padding-top: 0.4rem;
            }
            &:last-child {
                padding-bottom: 0.02rem;
                &::after {
                    display: none;
                }
            }
        }
    }

    // 隐藏话题调整
    &.hide-discussion {
        .discussion-content-list {
            .list-item {
                &:first-child {
                    padding-top: 0.02rem;
                }
            }
        }
    }

    // 黑肤颜色调整
    &.black {
        background-color: #0a0a0a;
        .discussion-container {
            background-color: #1b1f2a;
            .title {
                color: #e5e5e5;
            }
            .browse-count {
                color: #939393;
            }
        }
        .discussion-content-list {
            .list-item {
                .user {
                    .name-publish-time {
                        .name {
                            color: #e5e5e5;
                        }
                        .publish-time {
                            color: #9b9b9e;
                        }
                    }
                }
                .content-title {
                    color: #e5e5e5;
                }
                .content-description {
                    color: #e5e5e5;
                }
                &::after {
                    background-color: #333;
                }
            }
        }
    }

    // PC 尺寸调整
    &.isPC {
        .data-container {
            padding: 0;
        }
        .discussion-container {
            padding: 0.5rem 0.64rem;
            .title {
                font-size: 0.3rem;
            }
        }
        .discussion-content-list {
            .list-item {
                padding: 0.5rem 0;
                position: relative;
                .user {
                    margin-bottom: 0.24rem;
                    .avatar {
                        width: 0.72rem;
                        height: 0.72rem;
                        border-radius: 0.36rem;
                        margin-right: 0.2rem;
                    }
                    .name-publish-time {
                        .name {
                            font-size: 0.24rem;
                            margin-bottom: 0.04rem;
                        }
                        .publish-time {
                            font-size: 0.2rem;
                        }
                    }
                }
                .content-title {
                    font-size: 0.3rem;
                    margin-bottom: 0.12rem;
                }
                .content-stock-info {
                    font-size: 0.2rem;
                }
                .content-description {
                    font-size: 0.24rem;
                    -webkit-line-clamp: 3;
                    // 有股票信息的情况下，少一行
                    &.has-stock-info {
                        -webkit-line-clamp: 2;
                    }
                }
                &:last-child {
                    padding-bottom: 0.02rem;
                    &::after {
                        display: none;
                    }
                }
            }
        }
    }

    .tip-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 2rem;
    }
}
</style>
